// Epic categories and their epics for different project types
export const EPICS_DATA = {
  video_game: {
    label: "🎮 Video Games",
    epics: [
      { title: "Design", description: "Defining: Core mechanics, systems, loops, meta etc" },
      { title: "Gameplay", description: "Development: Character controls, combat, physics etc" },
      { title: "Engine/Tools", description: "Engine customization, dev tools etc" },
      { title: "UI/UX", description: "Menus, HUD, onboarding, accessibility etc" },
      { title: "Art", description: "Concepts, 2D/3D assets, environment, characters etc" },
      { title: "Animation", description: "Character, environment, VFX rigging etc" },
      { title: "Audio", description: "Music, SFX, VO integration etc" },
      { title: "Backend", description: "Matchmaking, persistence, social etc" },
      { title: "Testing", description: "Internal playtests, bug fixing etc" },
      { title: "Marketing", description: "Trailers, Steam page, socials etc" },
      { title: "Other", description: "Anything else that is not covered by the above categories" }
    ]
  },
  mobile_web_app: {
    label: "📱 Mobile or Web Apps",
    epics: [
      { title: "Design", description: "Flows, wireframes, UX research" },
      { title: "UX/UI", description: "Visual design, design system, prototyping" },
      { title: "Frontend", description: "React/Flutter/SwiftUI, animations" },
      { title: "Backend", description: "APIs, databases, auth" },
      { title: "DevOps", description: "CI/CD, hosting, monitoring" },
      { title: "Analytics", description: "Instrumentation, dashboards, AB testing" },
      { title: "Content", description: "Onboarding, help texts, microcopy" },
      { title: "Testing", description: "Unit, integration, UAT" },
      { title: "Marketing", description: "Launch site, ASO, ads, CRM" },
      { title: "Legal", description: "GDPR, ToS, accessibility" },
      { title: "Other", description: "Anything else that is not covered by the above categories" }
    ]
  },
  saas_platform: {
    label: "🖥️ SaaS Platforms",
    epics: [
      { title: "Product Management", description: "Roadmap, spec writing, priorities" },
      { title: "Research", description: "Interviews, personas, feedback loops" },
      { title: "UX/UI", description: "Components, responsive design" },
      { title: "Frontend", description: "Web UI, component libraries" },
      { title: "Backend", description: "Microservices, auth, billing, integrations" },
      { title: "Security", description: "SOC2, GDPR, login flows" },
      { title: "Customer Success", description: "Knowledge base, support" },
      { title: "Marketing", description: "Campaigns, SEO, onboarding" },
      { title: "Sales", description: "Demos, slide decks, CRM setup" },
      { title: "Ops", description: "Contracts, invoicing, team ops" },
      { title: "Legal", description: "GDPR, ToS, accessibility" },
      { title: "Other", description: "Anything else that is not covered by the above categories" }
    ]
  },
  digital_content_platform: {
    label: "🎬 Digital Content Platforms",
    epics: [
      { title: "Content", description: "Curation, deals" },
      { title: "UX/UI", description: "Browsing, playback, interactions" },
      { title: "Media", description: "Transcoding, CDN, storage" },
      { title: "User", description: "Profiles, subscriptions, preferences" },
      { title: "Monetization", description: "Ads, subs, partner payouts" },
      { title: "Moderation", description: "Flags, bans, filters" },
      { title: "Search", description: "Recommendations, trending, tags" },
      { title: "Social", description: "Comments, likes, share systems" },
      { title: "Analytics", description: "Creator dashboards, retention" },
      { title: "Marketing", description: "Influencer outreach, brand campaigns" },
      { title: "Other", description: "Anything else that is not covered by the above categories" }
    ]
  },
  ai_ml_product: {
    label: "🧠 AI / ML Products",
    epics: [
      { title: "Data", description: "Pipelines, ETL, labeling" },
      { title: "Model", description: "Training, tuning, evaluation" },
      { title: "Ops", description: "Deployment, monitoring, versioning" },
      { title: "Product", description: "Use cases, ethics, explainability" },
      { title: "Frontend", description: "Prompt UIs, visual feedback" },
      { title: "Backend", description: "Model integration, latency optimization" },
      { title: "Legal", description: "Data use compliance, bias audits" },
      { title: "Customer", description: "Examples, docs, tutorials" },
      { title: "Marketing", description: "Evangelism, partnerships" },
      { title: "Other", description: "Anything else that is not covered by the above categories" }
    ]
  }
}; 